import React, { useEffect, useMemo, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { listCabPackageLocations } from '../../api/cabsPublic';
import CabsBreadcrumbs from './CabsBreadcrumbs';

const CabsPackagesLanding = () => {
  const [searchParams] = useSearchParams();
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    listCabPackageLocations()
      .then((res) => setLocations(res.data || res || []))
      .catch(() => setLocations([]))
      .finally(() => setLoading(false));
  }, []);

  const passengers = useMemo(() => searchParams.get('passengers') || '1', [searchParams]);

  return (
    <section className="space-y-6">
      <CabsBreadcrumbs
        items={[{ label: 'Home', to: '/' }, { label: 'Cabs', to: '/cabs' }, { label: 'Packages' }]}
      />

      <div>
        <h1 className="text-2xl font-semibold text-slate-900">Transport packages by location</h1>
        <p className="text-sm text-slate-600">Explore multi-day itineraries tailored to each region.</p>
      </div>

      {loading && (
        <div className="rounded-2xl border border-slate-200 bg-white p-6 text-sm text-slate-500">
          Loading locations...
        </div>
      )}

      {!loading && locations.length === 0 && (
        <div className="rounded-2xl border border-slate-200 bg-white p-6 text-sm text-slate-500">
          No packages available yet.
        </div>
      )}

      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {locations.map((loc) => (
          <Link
            key={loc.id}
            to={`/cabs/packages/list?location=${encodeURIComponent(loc.slug || loc.id)}&passengers=${encodeURIComponent(passengers)}`}
            className="group overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm"
          >
            <div className="h-44 overflow-hidden bg-slate-100">
              {loc.imageUrl ? (
                <img src={loc.imageUrl} alt={loc.name} className="h-full w-full object-cover transition group-hover:scale-105" />
              ) : (
                <div className="flex h-full items-center justify-center text-xs text-slate-400">No image</div>
              )}
            </div>
            <div className="p-4">
              <h3 className="text-lg font-semibold text-slate-900">{loc.name}</h3>
              <p className="text-xs text-slate-500">{[loc.city, loc.state].filter(Boolean).join(', ')}</p>
              <p className="mt-3 text-xs text-slate-600">
                {loc.packageCount || 0} packages ·{' '}
                {loc.minStartingPrice ? `from INR ${loc.minStartingPrice}` : 'price on request'}
              </p>
            </div>
          </Link>
        ))}
      </div>

      <div className="rounded-2xl border border-slate-200 bg-white p-4 text-sm text-slate-600">
        Want to browse everything?{' '}
        <Link to={`/cabs/packages/list?passengers=${encodeURIComponent(passengers)}`} className="font-semibold text-slate-900">
          View all packages
        </Link>
        .
      </div>
    </section>
  );
};

export default CabsPackagesLanding;
